"use strict";
var getBuiltIn = require("../internals/get-built-in");
var defineWellKnownSymbol = require("../internals/well-known-symbol-define");
var setToStringTag = require("../internals/set-to-string-tag");
defineWellKnownSymbol("toStringTag");
setToStringTag(getBuiltIn("Symbol"), "Symbol");
